<script>
    // paramètres bind
    export let score, averageTimeReaction, bestTimeReaction;
</script>

<style>
    .last-result {
        @apply grid m-auto text-3xl font-normal pb-2 w-4/5;
        grid-template-columns: 0.5fr 1fr;
    }
</style>

<div class="last-result">
    <div class="flex justify-center items-center">
        {score}
    </div>
    <div class="flex flex-col justify-center text-center">
        <div class="text-lg">
            Moyenne : <span class="text-xl font-semibold">{averageTimeReaction}</span><span class="ms">ms</span>
        </div>
        <div class="text-lg">
            Meilleur : <span class="text-xl font-semibold">{bestTimeReaction}</span><span class="ms">ms</span>
        </div>
    </div>
</div>